/**
 * 全局体力不足弹窗管理器
 * 用于管理 ChatInsufficientPhysicalStrength 等全局弹窗
 */

import { ref } from 'vue'

// 全局状态
const showInsufficientPhysicalStrengthDialog = ref(false)

// 显示体力不足弹窗
export function openInsufficientPhysicalStrengthDialog() {
    showInsufficientPhysicalStrengthDialog.value = true
}

// 关闭体力不足弹窗
export function closeInsufficientPhysicalStrengthDialog() {
    showInsufficientPhysicalStrengthDialog.value = false
}

// useInsufficientPhysicalStrengthDialog composable
export function useInsufficientPhysicalStrengthDialog() {
    return {
        showInsufficientPhysicalStrengthDialog,
        openInsufficientPhysicalStrengthDialog,
        closeInsufficientPhysicalStrengthDialog
    }
}

